/**
 * Badge Styles supported by the badge visual widget
 */
export const BADGE_STYLE = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    WARNING: 'warning',
    INFO: 'info',
    DANGER: 'danger',
    SUCCESS: 'success',
    DARK: 'dark',
    POSITIVE: 'positive',
    NEGATIVE: 'negative',
    NEUTRAL: 'neutral',
};
//# sourceMappingURL=badge_style.js.map